import { z } from "zod";
import type { SavePlannerRule } from "./plannerRules.js";

export const interpretPlannerRuleSchema = z.object({
  text: z.string().trim().min(1).max(4000),
  projectId: z.string().trim().min(1).max(200).optional(),
  answers: z.array(z.object({ question: z.string().trim().min(1).max(400), answer: z.string().trim().min(1).max(1000) }).strict()).max(5).default([]),
}).strict();
export type InterpretPlannerRuleInput = z.input<typeof interpretPlannerRuleSchema>;
export interface PlannerRuleCatalog {
  workers: Array<{ id: string; name: string }>;
  projects: Array<{ id: string; name: string }>;
  tasks: Array<{ id: string; name: string; projectId: string }>;
}
export interface PlannerRuleInterpretation {
  id: string;
  status: "ready" | "clarification_required" | "unsupported";
  message: string;
  questions: string[];
  rule: SavePlannerRule | null;
}
export type PlannerRuleInterpretationResponse = PlannerRuleInterpretation | { id: string; status: "processing" };
export interface PlannerRuleDraftContext { catalog: PlannerRuleCatalog; available: boolean }

export const plannerRuleKindLabels = {
  worker_task_exclusion: "배정 제외", worker_task_preference: "우선 배정", task_not_before: "시작 가능 시각",
  task_deadline: "완료 기한", worker_unavailable: "근무 불가",
} as const;
